// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'components.placeholderPage.eyebrow': 'Backoffice',
    'components.placeholderPage.comingSoon': 'Em breve',
    'components.placeholderPage.description':
      'Este módulo entra nas próximas entregas. A base (login, navegação e dashboard) já está funcionando — vamos crescer daqui.',
  },
  en: {
    'components.placeholderPage.eyebrow': 'Backoffice',
    'components.placeholderPage.comingSoon': 'Coming soon',
    'components.placeholderPage.description':
      'This module is coming in future releases. The foundation (sign-in, navigation, and dashboard) is already working — we will build from here.',
  },
  es: {
    'components.placeholderPage.eyebrow': 'Backoffice',
    'components.placeholderPage.comingSoon': 'Próximamente',
    'components.placeholderPage.description':
      'Este módulo llegará en las próximas entregas. La base (inicio de sesión, navegación y panel) ya está funcionando; creceremos desde aquí.',
  },
}
